import { render, staticRenderFns } from "./ItemCompositionContent.vue?vue&type=template&id=17e01591&"
import script from "./ItemCompositionContent.vue?vue&type=script&lang=js&"
export * from "./ItemCompositionContent.vue?vue&type=script&lang=js&"
import style0 from "./ItemCompositionContent.vue?vue&type=style&index=0&id=17e01591&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCard, BCol, BRow})
    

export default component.exports